/**
* A collection of constants used for managing and configuring link previews within the chat application.
* These constants are immutable and are primarily used for accessing metadata and injected data related to link previews.
*/

export const LinkPreviewConstants = Object.freeze({
    metadata: "metadata",
    injected: "@injected",
    extensions: "extensions",
    link_preview: "link-preview",
    links: "links"
})